import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DailyQuestionPage } from "./components/DailyQuestionPage";

const queryClient = new QueryClient();

export function DailyQuestionApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* Daily question route - /daily-question/:token */}
        <Route path=":token" element={<DailyQuestionPage />} />
      </Routes>
    </QueryClientProvider>
  );
}
